import { GetStaticPaths, GetStaticProps } from "next";
import { ElementorLandingPage } from "@/routes/Unauth/ElementorLandingPage";
import { SUPPORTED_LOCALES, Locale } from "@/constants/landingPages";
import { ElementorContent } from "@/types/elementorContent";

interface ElementorPageProps {
  content: ElementorContent;
  locale: Locale;
  platform: string;
}

export default function ElementorPage({ content, locale, platform }: ElementorPageProps) {
  return <ElementorLandingPage content={content} locale={locale} platform={platform} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = SUPPORTED_LOCALES.map((locale) => ({
    params: { locale },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<ElementorPageProps> = async ({ params }) => {
  const locale = params?.locale as Locale;
  const platform = "elementor";

  try {
    // Dynamically load content for the given locale
    const content = await import(`@/content/landing/${locale}/${platform}.json`);

    return {
      props: {
        content: content.default as ElementorContent,
        locale,
        platform,
      },
    };
  } catch (error) {
    // If content for locale doesn't exist, fallback to English
    const content = await import(`@/content/landing/en/${platform}.json`);

    return {
      props: {
        content: content.default as ElementorContent,
        locale,
        platform,
      },
    };
  }
};
